export const ENERGY_VARIABLE_NAME = {
  HEATING_DEMAND_SPACE: 'heating_demand_space',
  HEATING_DEMAND_TAPWATER: 'heating_demand_tapwater',
  POST_HEATING_DEMAND: 'post_heating_demand',
  COOLING_DEMAND_SPACE: 'cooling_demand_space',
  PRE_COOLING_DEMAND: 'pre_cooling_demand',
} as const;

export type EnergyExpressionVariables = {
  [ENERGY_VARIABLE_NAME.HEATING_DEMAND_SPACE]: number;
  [ENERGY_VARIABLE_NAME.HEATING_DEMAND_TAPWATER]: number;
  [ENERGY_VARIABLE_NAME.POST_HEATING_DEMAND]: number;
  [ENERGY_VARIABLE_NAME.COOLING_DEMAND_SPACE]: number;
  [ENERGY_VARIABLE_NAME.PRE_COOLING_DEMAND]: number;
};
